export * from './props';
export * from './errors';

import { default as Field } from './Field.vue';
import { default as EditorField } from './EditorField.vue';
import { default as PasswordField } from './PasswordField.vue';
import { default as SkeletonField } from './SkeletonField.vue';
import { default as SwitchField } from './SwitchField.vue';
import { default as TextAreaField } from './TextAreaField.vue';
import { default as TextField } from './TextField.vue';
import { default as AutoCompleteField } from './AutoCompleteField.vue';
import { default as RadioGroupField } from './RadioGroupField.vue';
import { default as AddressField } from './AddressField.vue';
import { default as AnswerQuestionInput } from './AnswerQuestionInput.vue';

export {
    Field,
    EditorField,
    PasswordField,
    SkeletonField,
    SwitchField,
    TextAreaField,
    TextField,
    AutoCompleteField,
    RadioGroupField,
    AddressField,
    AnswerQuestionInput,
};

export { type ClauseBuilderField } from './WhereClauseBuilder.vue';
export {
    default as WhereClauseListBuilder,
    type ClauseBuilderDefinition,
} from './WhereClauseListBuilder.vue';

import type { App } from 'vue';

export default {
    install(app: App) {
        // eslint-disable-next-line vue/multi-word-component-names
        app.component('Field', Field);

        app.component('EditorField', EditorField);
        app.component('PasswordField', PasswordField);
        app.component('SkeletonField', SkeletonField);
        app.component('SwitchField', SwitchField);
        app.component('TextAreaField', TextAreaField);
        app.component('TextField', TextField);
        app.component('RadioGroupField', RadioGroupField);
        app.component('AddressField', AddressField);
        app.component('AnswerQuestionInput', AnswerQuestionInput);
    },
};
